import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";

const EVENTS = [
  { time: "8:02 AM", label: "Payment Secured" },
  { time: "8:14 AM", label: "Driver Accepted" },
  { time: "9:01 AM", label: "Pickup Completed" },
  { time: "11:48 AM", label: "HOS Warning", alert: true },
  { time: "12:03 PM", label: "Relief Requested" },
  { time: "12:14 PM", label: "Relief Driver Accepted" },
  { time: "12:52 PM", label: "Relief Driver Arrived" },
  { time: "1:08 PM", label: "Handoff Verified" },
  { time: "1:09 PM", label: "Custody Transferred" },
  { time: "4:47 PM", label: "Delivered" },
  { time: "4:52 PM", label: "POD Verified" },
  { time: "4:53 PM", label: "Payment Release Authorized" },
];

export const AssignmentTimeline = () => {
  return (
    <section data-testid="assignment-timeline-section" className="py-24 md:py-32 bg-rr-surface">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <SectionHeading eyebrow="Real-Time Assignment Timeline" title="Know What Happened and When." align="center" testId="assignment-timeline" />

        <div className="mt-16 relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-rr-line" />
          {EVENTS.map((ev, i) => (
            <Reveal key={ev.time + ev.label} delay={i * 0.04}>
              <div className={`relative flex items-center mb-6 md:w-1/2 ${i % 2 === 0 ? "md:pr-10 md:ml-0" : "md:pl-10 md:ml-auto md:flex-row-reverse"}`}>
                <div
                  className={`absolute md:static left-4 md:left-auto -translate-x-1/2 md:translate-x-0 w-3 h-3 rounded-full border-2 border-white shrink-0 ${
                    ev.alert ? "bg-rr-red" : "bg-rr-orange"
                  }`}
                />
                <div
                  data-testid={`timeline-event-${i}`}
                  className={`ml-8 md:ml-0 ${i % 2 === 0 ? "md:mr-4" : "md:ml-4"} bg-white border border-rr-line rounded-xl px-4 py-3 flex-1`}
                >
                  <span className="text-xs font-bold text-rr-orange">{ev.time}</span>
                  <p className={`text-sm font-semibold mt-0.5 ${ev.alert ? "text-rr-red" : "text-rr-navy"}`}>{ev.label}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
